import { Axios } from 'src/service/axios/axios'
import { DOSSIER_STATUS_TYPE } from 'src/shared/constants/constants'
import { NextState } from 'src/shared/constants/workflow-constants'

const BASE_URL = '/api/program/workflow'

const nextStates = async (workflowId: string): Promise<Array<NextState>> => {
  return Axios.getAxios()
    .get(`${BASE_URL}/${workflowId}/next-states`)
    .then((response) => response.data)
}

const transition = async (workflowId: string, state: DOSSIER_STATUS_TYPE, lang: string): Promise<Array<NextState>> => {
  return Axios.getAxios()
    .post(`${BASE_URL}/${workflowId}/transition-to/${state}?lang=${lang}`)
    .then((response) => response.data)
}

const deleteProgram = async (programId: number): Promise<boolean> => {
  return Axios.getAxios()
    .delete(`${BASE_URL}/${programId}`)
    .then((response) => response.data)
}

export const ProgramWorkflowService = {
  nextStates,
  transition,
  deleteProgram,
}
